import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'app/lib/api.service';
import { LogService } from 'app/lib/log.service';
import { ModalService } from 'app/lib/modal.service';
import { Daily, DailyContent } from "../../../models/course";

@Component({
  selector: 'app-daily-series-add',
  templateUrl: './daily-series-add.component.html',
  styleUrls: ['./daily-series-add.component.scss']
})
export class DailySeriesAddComponent implements OnInit {
  courseEditForm: FormGroup;
  title: string;
  daily: Daily;
  isLoaded: boolean = false;
  config: any;
  panelState: Array<boolean>;
  submitButtonPressed: boolean = false;
  errors: string = "";
  categoryList: any;
  logService: any;
  dailyGroups: any;
  groupId: any;
  titleData: any;
  constructor(private translate: TranslateService,
    private formBuilder: FormBuilder,
    private api: ApiService,
    private log: LogService,
    private modalService: ModalService,
    public dialogRef: MatDialogRef<DailySeriesAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.groupId = data.data.data;
     this.daily = new Daily({});
    this.createCourseEditForm(new Daily({}));
    this.title = "Add Daily Content"
  }

  get f() {
    return this.courseEditForm.controls;
  }

  createCourseEditForm(data: any) {
    this.courseEditForm = this.formBuilder.group({      
      groupname: [{ value: data.groupname || "", disabled: true }, [Validators.required]],
      dailydata: this.formBuilder.array([]),
    });

    data.dailydata?.forEach((data: any) => {
      this.addDailyContentItem(data);
    });
  }

  get dailydata() {
    return this.courseEditForm.get("dailydata") as FormArray;
  }

  getDailyAddFormGroup(index: number): FormGroup {
    const dailyaddForm = this.courseEditForm.get("dailydata") as FormArray;
    const formGroup = dailyaddForm.controls[index] as FormGroup;
    return formGroup;
  }

  onRemoveDailyContentItem(index: number) {
    const dailydataArray = this.courseEditForm.get('dailydata') as FormArray;
    if (dailydataArray.length > 1) {
      dailydataArray.removeAt(index);
    }
  }

  ngOnInit(): void {
    this.api.get("series/dailyseries/getgroups").subscribe(
			(result: any) => {
				this.isLoaded = true;
				if (result) {
					if(result.length != 0){
					this.dailyGroups = result;
          this.titleData = this.dailyGroups.find(g => g.ID === this.groupId);
          const data = {
            "groupname" : this.titleData.Name
          }
          this.createCourseEditForm(data)
					}
				}
				this.isLoaded = true;
			},
			(error: any) => {
				this.logService.debug(
					"Error getting series. " + error.message
				);
				this.isLoaded = true;
			}
		);

    this.api
        .get("series/categories")
        .subscribe(
          (result: any) => {
            this.categoryList = result;
            this.isLoaded = true;
          },
          (error: any) => {
            this.log.error(
              "Error getting organizations. " + error.message
            );
          }
        );
  }


  doSave() {
  this.daily = new Daily(this.courseEditForm.value);
    this.submitButtonPressed = true;
    this.errors = "";
    if (
      !this.daily.dailycontents ||
      this.daily.dailycontents.length === 0
    ) {
      this.errors = "The series needs at least one daily content";
      return;
    } else {
      let j = 1;
      this.daily.dailycontents.some((dailyData) => {
        if (!dailyData.category) {
          this.errors = `Daily series category ${j} missing`;
          return true;
        } else if (!dailyData.quotesen) {
          this.errors = `Daily series Quote (English) ${j} missing`;
          return true;
        } else if (!dailyData.quotesfr) {
          this.errors = `Daily series Quote (French) ${j} missing`;
          return true;
        } else if (!dailyData.quoteses) {
          this.errors = `Daily series Quote (Spanish) ${j} missing`;
          return true;
        }
        j++;
        return false;
      });
    }

    if (this.errors) {
      // errors = "The following errors were found:<br>" + errors;
      // this.modalService.showAlert("Error", errors);
      return;
    }
    this.log.debug('series ouput');
    this.log.debug(Daily.forAPI(this.daily, this.titleData.ID));
    this.isLoaded = false;
      this.api
        .post(
          "series/dailyseries/add",
          Daily.forAPI(this.daily, this.titleData.ID),
          true
        )
        .subscribe(
          (data: any) => {
            this.modalService.showAlert(
              "Success",
              "Daily series content has been added"
            );
            this.isLoaded = true;
            this.dialogRef.close({ data:data, groupId: this.titleData.ID });
          },
          (error: any) => {
            this.isLoaded = true;
            this.modalService.showAlert(
              "Error",
              "Something went wrong. " + error.message
            );
          }
        );
  }

  addDailyContentItem(data: any) {
    if (!this.daily) {
      this.daily = new Daily({});
    }
    this.daily.dailycontents.push(new DailyContent({}));
    const addDailyList = this.courseEditForm.get('dailydata') as FormArray;
    addDailyList.push(this.createDailyContentList(data));
  }

  createDailyContentList(data: any): FormGroup {
    return this.formBuilder.group({
      id: [data.id || null],
      category: [data.category || "", [Validators.required]],
      quotesen: [data.quotesen || "", [Validators.required]],
      quotesfr: [data.quotesfr || "", [Validators.required]],
      quoteses: [data.quoteses || "", [Validators.required]]
    });
  }

  onRemoveCourseItem(i: number, data: any) {
    this.daily.dailycontents.splice(i, 1);
    const chapterList = this.courseEditForm.get('chapters') as FormArray;
    chapterList.removeAt(i);
  }

  onClose() {
    this.dialogRef.close();
  }
}
